"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.active.help': 'Włącz tę wiedzę do użytku',
};
